import { render, staticRenderFns } from "./ClubsMembersEditDialog.vue?vue&type=template&id=622dad60&"
import script from "./ClubsMembersEditDialog.vue?vue&type=script&lang=ts&"
export * from "./ClubsMembersEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ClubsMembersEditDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports